<template>
  <div class="container" ref="document" id="document">
    <div class="receipt-wrapper">
      <div class="receipt-card">
        <div class="receipt-header">
          <p class="h1 mb-3 font-weight-bold gray-text">{{$t("message.receipt")}}</p>
          <p class="h6 py-1 receipt-subtitles gray-text">
            {{$tc("message.receiptheaders", 0)}}: {{transactionData.created_at}}
          </p>
          <p class="h6 py-1 receipt-subtitles">
            {{$tc("message.receiptheaders", 1)}}: {{transactionData.buyer_name}}
          </p>
          <p class="h6 py-1 receipt-subtitles">
            {{$tc("message.receiptheaders", 2)}}: {{transactionData.payment_external_id}}
          </p>
          <template v-if="showLogo">
            <img width="56" crossorigin="*" v-if="getLogoUrl" height="56" :src="getLogoUrl" class="company_logo">
          </template>
        </div>
        <div class="receipt-body">
          <table>
            <thead>
              <td>
                {{$t("message.restaurant")}} #
              </td>
              <td>
                {{$t("message.managerName")}}
              </td>
              <td>
                {{$t("message.ptsPurchased")}}
              </td>
              <td>
                {{$t("message.totalCost")}}
              </td>
            </thead>
            <tbody>
              <tr v-for="(data, index) in transactionData.managers" :key="index" class="table-row">
                <td class="table-col">
                  {{data.recipient_department_name}}
                </td>
                <td class="table-col">
                  {{data.recipient_first_name}} {{data.recipient_last_name}}
                </td>
                <td class="table-col text-right">
                  {{data.funded_points.toLocaleString()}} pts
                </td>
                <td class="table-col text-success text-right">
                  ${{data.funded_dollars}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="subtotal-wrapper">
          <div class="subtotal-card">
            <div class="d-flex space-between py-3">
              <p class="subtitle">{{$tc("message.receiptSummarytitles", 2)}}</p>
              <p class="subtotal-title">${{getSubtotal}}</p>
            </div>
            <div class="d-flex space-between py-3">
              <p class="subtitle">{{$tc("message.receiptSummarytitle", 0)}}</p>
              <p class="subtotal-title">${{transactionData.service_fee | formatNumber}}</p>
            </div>
            <div class="d-flex space-between py-3">
              <p class="subtitle">{{$tc("message.receiptSummarytitle", 1)}}</p>
              <p class="subtotal-title">${{transactionData.tax | formatNumber}}</p>
            </div>
            <div class="divider">
            </div>
            <div class="d-flex space-between py-3">
              <p class="subtitle">{{$tc("message.receiptSummarytitle", 2)}}</p>
              <div>
                <p class="subtotal-title text-success">${{transactionData.total | formatNumber}}</p>
                <p class="subtitle py-2">{{transactionData.total_points.toLocaleString()}} points</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['transactionData'],
  data() {
    return {
      showLogo: false
    }
  },
  created() {
    this.showLogo = process.env.VUE_APP_SHOW_LOGO.toLowerCase() === "true" ? true : false
  },
  computed: {
    getSubtotal () {
      let subtotal = 0
      this.transactionData.managers.forEach(val => {
        subtotal += val.funded_dollars
      })
      let number_format;
      return Number(subtotal).toLocaleString(number_format, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    getLogoUrl () {
      return process.env.VUE_APP_LOGO_URL || null
    }
  }
}
</script>
<style scoped>
.container {
  padding: 30px;
}
.receipt-header {
  margin-bottom: 20px;
  position: relative;
}
table {
  width: 100%;
  font-size: 19px;
}
thead {
  background: #F8F8F8;
  width: 100%;
  color: #7D8C9B;
  border: 1px solid #d3d2d2;
}
thead td {
  padding: 20px;
  border-left: 1px solid #d3d2d2;
}
tbody {
  width: 100%;
  color: #45505B;
}
td {
  min-width: 25%;
}
.subtotal-card {
  min-width: 400px;
}
.subtotal-wrapper {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 20px;
}
.subtotal-card .subtitle {
  font-size: 16px;
  line-height:24px;
  color: #687888;
}
.subtotal-card .subtotal-title {
  font-size: 24px;
  line-height:20px;
  text-align: end;
  color:#45505B;
}
.divider {
  border-bottom: 1px solid #c4c2c2;
}
p {
  margin: 0;
}
.table-col {
    padding: 20px;
}
.table-row {
  border: 1px solid #d3d2d2;
  border-top: none;
}
.space-between {
  justify-content:space-between;
}
.receipt-subtitles {
  color:#687888;
  font-size: 21px;
}
.receipt-wrapper{
  width:1224px;
  height:1584px;
  padding: 100px;
}
.receipt-card {
  width: 1024px;
}
.gray-text {
  color:#45505B;
}
.company_logo{
  width: 56px;
  height: 56px;
  border-radius: 5px;
  position: absolute;
  right: 0;
  top: 0;
}
</style>